'use strict';
import listActions  from '../actions/listActions';
import {fromJS}     from 'immutable';

const INITIAL_STATE = fromJS({
  templates          : {},
  tempTemplates      : {},
  isLoadingTemplates : false,
  locale             : 'fr',
});

const langueReducer = (state, action) => {
  if (!state){
    state = INITIAL_STATE;
  }

  if (!action.type) {
    return state;
  }

  switch (action.type) {

    case listActions.UPDATE_TEMP_TEMPLATES : {
      return state.set('tempTemplates', fromJS(action.templates));
    }

    case listActions.CHANGE_CURRENT_LANGUE : {
      return state.set('locale', action.lang);
    }

    case listActions.GET_TEMPLATES_START : {
      return state.set('isLoadingTemplates', true);
    }

    case listActions.GET_TEMPLATES_FAIL: {
      return state.set('isLoadingTemplates', false);
    }

    case listActions.GET_TEMPLATES_SUCCESS: {
      return state
        .set('templates', fromJS(action.templates))
        .set('isLoadingTemplates', false);
    }

    case listActions.EDIT_TEMPLATES: {
      return state.set('templates', fromJS(action.templates));
    }

    case listActions.EDIT_TEMPLATES_SUCCESS: {
      const newTemplates = state.get('tempTemplates');
      return state
        .set('templates', newTemplates)
        .set('isLoadingTemplates', false);
    }

    default : {
      return state;
    }

  }
};

export default langueReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/langueReducer.js